import { IMessageConverter, IMessageData } from '@uxdf/direct-shared-lib';
import { BookMessageTypes, ParserMessageTypes } from '../models/message.model';

export class ParserMessageConverter implements IMessageConverter {
  execute(e: MessageEvent): IMessageData {
    const type = e.data.type;
    if (type === ParserMessageTypes.SEND_DATA) {
      return (({ id, data }) => ({ id, data, type: BookMessageTypes.CREATE_QUOTATION }))(e.data);
    }
  }
}

export class BookMessageConverter implements IMessageConverter {
  execute(e: MessageEvent): IMessageData {
    let msg: any;
    try {
      msg = JSON.parse(e.data);
    } catch (_) {
      return;
    }
    const type = msg.type;
    if (type === BookMessageTypes.PIN_STATUS) {
      return (({ id, data }) => ({ id, data, type: ParserMessageTypes.PIN_STATUS }))(msg);
    }
  }
}
